import React from "react";

export const Contact = ({ data }) => {
  // Helpers seguros
  const phone = data?.phone || "—";
  const email = data?.email || "—";
  const address = data?.address || "—";

  // Instagram: admite "hipica_madrid_campogrande" o "https://instagram.com/hipica_madrid_campogrande"
  const igRaw = data?.instagram || "";
  const igIsUrl = /^https?:\/\//i.test(igRaw);
  const igUrl = igIsUrl ? igRaw : igRaw ? `https://instagram.com/${igRaw}` : "";
  const igUser =
    igRaw
      .replace(/^https?:\/\/(www\.)?instagram\.com\//i, "")
      .replace(/\/$/, "") || (igRaw ? igRaw : "—");

  return (
  <div>
    {/* Override local solo para esta sección */}
    <style>{`
      /* Mata cualquier separador del template en esta sección */
      #contact .section-title.no-sep::after,
      #contact .section-title.no-sep::before,
      #contact .section-title.no-sep h2::after,
      #contact .section-title.no-sep h2::before {
        content: none !important;
        display: none !important;
      }
    `}</style>

    <div id="contact">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 text-center">
          {/* aquí añades no-sep */}
          <div className="section-title no-sep" style={{ marginBottom: 24 }}>
            <h2>Contacto</h2>

            {/* separador propio opcional */}
            <div
              style={{
                width: 64,
                height: 3,
                opacity: 0.5,
                background: "#fff",
                borderRadius: 2,
                margin: "12px auto 12px",
              }}
            />

            <p>Para más información podéis contactarnos en:</p>
          </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone" /> Móvil:
                </span>{" "}
                {phone}
              </p>
            </div>

            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-instagram" /> Instagram:
                </span>{" "}
                {igUrl ? (
                  <a
                    href={igUrl}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "#f39c12", textDecoration: "underline" }}
                  >
                    {igUser}
                  </a>
                ) : (
                  "—"
                )}
              </p>
            </div>

            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o" /> E-mail:
                </span>{" "}
                {email !== "—" ? (
                  <a
                    href={`mailto:${email}`}
                    style={{ color: "#f39c12", textDecoration: "underline" }}
                  >
                    {email}
                  </a>
                ) : (
                  "—"
                )}
              </p>
            </div>

            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-map-marker" /> Dirección:
                </span>{" "}
                {address}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div id="footer">
        <div className="container text-center">
          <p>© {new Date().getFullYear()} Hípica Madrid Campogrande</p>
        </div>
      </div>
    </div>
  );
};
